import moment from 'moment-timezone';
import React, { PureComponent, Fragment } from 'react';

class TimeZoneClock extends PureComponent {

  componentDidMount() {
    this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <Fragment>
        { moment(this.time).tz('America/Vancouver').format('LTS') }
      </Fragment>
    );
  }

}

export default TimeZoneClock;



// WEBPACK FOOTER //
// ./src/components/TimeZoneClock/TimeZoneClock.js